import { BaseSearchQueryField } from './base-search-query-field';
export class SimpleSearchQueryField extends BaseSearchQueryField {
  get urlSlugs() {
    return [this.urlSlug];
  }
  toUrlParameters() {
    if (this.isDefault()) {
      return [];
    }
    var paramValue = this.getUrlParameterValue();
    return paramValue == null ? [] : [{
      [this.urlSlug]: paramValue
    }];
  }
}